import { createFileRoute, redirect } from '@tanstack/react-router';

// The standalone corporate-actions calendar was unified into the Compliance page's
// Calendar tab (obligations + corporate actions on one grid). This route now just
// redirects any old link/bookmark to the tabbed Compliance page.
export const Route = createFileRoute('/compliance/calendar')({
  beforeLoad: () => {
    throw redirect({ to: '/compliance' });
  },
});
